module.exports = __webpack_public_path__ + "img/reset.a48709de.svg";